module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('img', {
    staticClass: "dp",
    attrs: {
      "src": _vm.url
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-730972a2","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dp.vue
// module id = 105
// module chunks = 0 1